import axios from 'axios';

const baseUrl = `${process.env.REACT_APP_QCX_API_BASE_URL}/${process.env.REACT_APP_QCX_API_CATALOGO_PRODUTOS_ENDPOINT}/relatorio-catalogo-produtos`;

const generateRelatorioCatalogoProdutos = async (
  token: string,
  tenantId: number,
  partnumber?: string,
  dataInicio?: string,
  dataFim?: string,
  fabricanteIds?: string[]
): Promise<string | null> => {
  const params = new URLSearchParams();

  if (partnumber && partnumber.trim()) {
    params.set('partnumber', partnumber.trim());
  }
  if (dataInicio && dataInicio.trim()) {
    params.set('dataInicio', dataInicio.trim());
  }
  if (dataFim && dataFim.trim()) {
    params.set('dataFim', dataFim.trim());
  }
  if (fabricanteIds && fabricanteIds.length > 0) {
    params.set('fabricanteIds', fabricanteIds.join(','));
  }

  const url = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;

  try {
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        quickcomexTenant: tenantId,
      },
      responseType: 'blob',
    });

    if (response.status === 200) {
      const file = new File([response.data], 'relatorio_catalogo_produtos.xlsx', {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = url;
      a.download = file.name;
      a.click();
      return null;
    }

    return await response.data.text();
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.data) {
      try {
        return await error.response.data.text();
      } catch {
        return 'Erro inesperado ao gerar relatório.';
      }
    }
    return 'Erro inesperado ao gerar relatório.';
  }
};

export default generateRelatorioCatalogoProdutos;
